import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription }                                       from 'rxjs';

import { IntelligenceRangeModel } from './typings/intelligence.range';
import { IntelligenceService }    from './intelligence.service';

interface PreviousSelection {
  end   : string;
  preset: string;
  start : string;
}

@Component({
  selector   : 'wor-intelligence-date-range-picker',
  template: require('./intelligence.date-range-picker.component.html')
})
export class DateRangePickerComponent implements OnInit, OnDestroy {
  @Output() rangeChange = new EventEmitter<IntelligenceRangeModel>();

  public activePreset : string = 'LAST_30';
  public customEnd    : string = '';
  public customStart  : string = '';
  public presets = [ 'TODAY', 'THIS_WEEK', 'LAST_WEEK', 'LAST_30', 'THIS_MONTH', 'LAST_MONTH', 'YTD', 'CUSTOM' ];
  public previous     : PreviousSelection = null;

  private subscription : Subscription;

  constructor (
    private intelligenceService: IntelligenceService
  ) {}

  ngOnInit () : void {
    this.customEnd = this.intelligenceService.range.end_date;
    this.customStart = this.intelligenceService.range.start_date;

    this.subscription = this.intelligenceService.rangeChanged.subscribe(range => {
      if ( range.start_date === this.customStart && range.end_date === this.customEnd ) {
        return;
      }

      if ( this.previous && range.start_date === this.previous.start && range.end_date === this.previous.end ) {
        this.activePreset = this.previous.preset;
        this.customEnd = this.previous.end;
        this.customStart = this.previous.start;
        this.previous = null;

        return;
      }

      if ( !this.previous ) {
        this.previous = {
          end   : this.customEnd,
          preset: this.activePreset,
          start : this.customStart
        };
      }

      this.activePreset = 'CUSTOM';
      this.customEnd = range.end_date;
      this.customStart = range.start_date;
    });
  }

  ngOnDestroy () : void {
    this.subscription.unsubscribe();
  }

  applyCustom () : void {
    if ( !this.customStart || !this.customEnd || this.customStart > this.customEnd ) {
      return;
    }

    this.previous = null;

    this.rangeChange.emit({
      end_date  : this.customEnd,
      start_date: this.customStart
    });
  }

  selectPreset ( preset : string ) : void {
    this.activePreset = preset;
    this.previous = null;

    if ( preset === 'CUSTOM' ) {
      return;
    }

    const range = this.intelligenceService.presetRange(preset);

    this.customEnd = range.end_date;
    this.customStart = range.start_date;

    this.rangeChange.emit(range);
  }
}
